import log from 'salvo-lite/log'

class ReadMore {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._data = JSON.parse(elem.getAttribute('data-read-more') || '{}')
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        // Get identifier and elements
        const targets = this._elem.parentNode.querySelectorAll('[data-read-more-content]')

        targets.forEach((target) => {
            const rteElement = target.querySelector('.rte')

            // Add click event content
            if (rteElement.innerText.length > this._data.max_chars || window.innerWidth < 400) {
                this._addReadMoreClickListener(target)
                this._elem.classList.remove('hidden')
            }
        })
    }

    _addReadMoreClickListener (target) {
        // Get close cta
        const closeCta = this._elem.parentNode.querySelector('[data-read-more-close]')

        this._elem.addEventListener('click', (e) => {
            target.classList.toggle('open')
            this._elem.parentNode.classList.toggle('open')
            this._elem.classList.toggle('hidden')
            closeCta.classList.toggle('hidden')
        })

        closeCta.addEventListener('click', (e) => {
            target.classList.toggle('open')
            this._elem.parentNode.classList.toggle('open')
            this._elem.classList.toggle('hidden')
            closeCta.classList.toggle('hidden')
        })
    }
}

export default ReadMore



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ReadMore.js